/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { EdiInboundNodeFragmentDoc } from './EdiInboundNodeFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IEdiInboundConnectionConfigQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']
}>

export type IEdiInboundConnectionConfigQuery = { __typename?: 'Query' } & {
  ediInboundConnectionConfig?: Types.Maybe<
    { __typename?: 'InboundConnectionConfig' } & Pick<
      Types.IInboundConnectionConfig,
      | 'id'
      | 'partnerApplicationId'
      | 'partnerApplicationType'
      | 'connectionType'
      | 'disabled'
      | 'environment'
      | 'host'
      | 'port'
      | 'username'
      | 'secretKey'
      | 'pathPrefix'
      | 'filenameGlob'
      | 'createdAt'
      | 'send997s'
    > & {
        partnerApplication?: Types.Maybe<
          | ({ __typename: 'CarrierApplication' } & Pick<Types.ICarrierApplication, 'id'> & {
                carrierName: Types.ICarrierApplication['name']
              })
          | ({ __typename: 'ShipperApplication' } & Pick<Types.IShipperApplication, 'id'> & {
                shipperName: Types.IShipperApplication['name']
              })
        >
        as2ConnectionConfig?: Types.Maybe<
          { __typename?: 'As2ConnectionConfig' } & Pick<
            Types.IAs2ConnectionConfig,
            | 'id'
            | 'createdAt'
            | 'identifier'
            | 'outboundUrl'
            | 'serverInfoCredentialsIdentifier'
            | 'transfixIdentifier'
            | 'updatedAt'
          > & {
              as2Certificates: Array<
                { __typename?: 'As2Certificate' } & Pick<
                  Types.IAs2Certificate,
                  | 'id'
                  | 'body'
                  | 'x509ReadError'
                  | 'notAfter'
                  | 'notBefore'
                  | 'createdAt'
                  | 'isActive'
                  | 'updatedAt'
                >
              >
            }
        >
        configGroupMappings?: Types.Maybe<
          Array<
            { __typename?: 'ConfigGroupMapping' } & Pick<
              Types.IConfigGroupMapping,
              | 'id'
              | 'isaSenderId'
              | 'createdAt'
              | 'ediMapperConfigGroupId'
              | 'inboundEdiMapperConnectionConfigId'
              | 'updatedAt'
            > & {
                configGroup?: Types.Maybe<
                  { __typename?: 'ConfigGroup' } & Pick<
                    Types.IConfigGroup,
                    'id' | 'name' | 'createdAt' | 'shipperApplicationId' | 'updatedAt'
                  >
                >
              }
          >
        >
      }
  >
}

export const EdiInboundConnectionConfigDocument = gql`
  query EdiInboundConnectionConfig($id: ID!) {
    ediInboundConnectionConfig(id: $id) {
      ...EdiInboundNode
    }
  }
  ${EdiInboundNodeFragmentDoc}
`

/**
 * __useEdiInboundConnectionConfigQuery__
 *
 * To run a query within a React component, call `useEdiInboundConnectionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdiInboundConnectionConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdiInboundConnectionConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEdiInboundConnectionConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    IEdiInboundConnectionConfigQuery,
    IEdiInboundConnectionConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IEdiInboundConnectionConfigQuery,
    IEdiInboundConnectionConfigQueryVariables
  >(EdiInboundConnectionConfigDocument, options)
}
export function useEdiInboundConnectionConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IEdiInboundConnectionConfigQuery,
    IEdiInboundConnectionConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IEdiInboundConnectionConfigQuery,
    IEdiInboundConnectionConfigQueryVariables
  >(EdiInboundConnectionConfigDocument, options)
}
export type EdiInboundConnectionConfigQueryHookResult = ReturnType<
  typeof useEdiInboundConnectionConfigQuery
>
export type EdiInboundConnectionConfigLazyQueryHookResult = ReturnType<
  typeof useEdiInboundConnectionConfigLazyQuery
>
export type EdiInboundConnectionConfigQueryResult = Apollo.QueryResult<
  IEdiInboundConnectionConfigQuery,
  IEdiInboundConnectionConfigQueryVariables
>
